window.addEventListener('DOMContentLoaded', function (e) {
  const arrowWrappers = document.querySelectorAll('.arrow-wrapper');
  const parent = document.querySelector('.hero_slider');
  arrowWrappers.forEach((arrow) => {
    arrow.addEventListener('click', () => {
      if (parent) {
        window.scrollBy(0, parent.getBoundingClientRect().bottom);
      }
    });
  });
});
